import { GradeEntityInput } from "../../../services/grade/grade.types";

export const initialValuesGrade: GradeEntityInput = {
  grade: "",
  code: "",
};
